<template>
  <div class="popup">
    <a-modal
        title="修改群名称"
        :visible="visible"
        okText="确定"
        cancelText="取消"
        @cancel="cancel"
        @ok="ok"
        width="280px"
    >
      <div class="search">
        <a-input placeholder="请输入群名称" style="width: 200px" v-model="name" />
      </div>
    </a-modal>
  </div>
</template>

<script>

export default {

  props:["item"],
  data() {
    return {
      visible: false,
      name:""
    }
  },
  methods: {
    
    ok() {

      this.visible = false;
      this.item.groupName = this.name;

      // this.$emit('change', item);
    },
    show(name) {
       this.name = name;
      this.visible = true;
     
    },
    cancel(){
      this.visible = !this.visible;
      this.name = "";
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
  // height: 300px;
  overflow: auto;
}

.search {
  width: 100%;
  margin-bottom: 20px;

  /deep/ .ant-input-search {
    width: 100% !important;
  }
}

.list {
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;

    .info {
      display: flex;
      align-items: center;
    }

    .avatar {
      img {
        width: 35px;
        height: 35px;
        border-radius: 3px;
        margin-right: 6px;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
